
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.854.96a.75.75 0 00-1.041 1.08L8.853.96zM13 6l.52.54a.75.75 0 000-1.08L13 6zM7.813 9.96a.75.75 0 001.04 1.08l-1.04-1.08zM1 5.25a.75.75 0 000 1.5v-1.5zm6.813-3.21l4.666 4.5 1.042-1.08L8.854.96 7.813 2.04zm4.666 3.42l-4.666 4.5 1.04 1.08 4.668-4.5-1.042-1.08zM13 5.25H1v1.5h12v-1.5z","fill":"#fff"}})])
          )
        }
      }
    